import { C } from "@/lib/brand";

export function Eyebrow({ children, color = C.peachDeep, className = "", testId }) {
  return (
    <div
      data-testid={testId}
      className={className}
      style={{
        fontSize: 11,
        fontWeight: 800,
        letterSpacing: "0.2em",
        textTransform: "uppercase",
        color,
      }}
    >
      {children}
    </div>
  );
}

export function Headline({ before, italic, after, color = C.ink, italicColor, size = 64, className = "", as = "h1" }) {
  const Comp = as;
  return (
    <Comp
      className={className}
      style={{
        margin: 0,
        fontWeight: 800,
        fontFamily: '"DM Sans", sans-serif',
        fontSize: size,
        lineHeight: 0.95,
        letterSpacing: "-0.04em",
        color,
        textTransform: "uppercase",
      }}
    >
      {before}
      {italic && (
        <>
          {before ? " " : ""}
          <span
            style={{
              fontFamily: '"Instrument Serif", Georgia, serif',
              fontStyle: "italic",
              fontWeight: 400,
              textTransform: "none",
              color: italicColor || color,
              letterSpacing: "-0.02em",
            }}
          >
            {italic}
          </span>
        </>
      )}
      {after && (
        <>
          {italic ? " " : ""}
          {after}
        </>
      )}
    </Comp>
  );
}
